import { render, staticRenderFns } from "./InSurance.vue?vue&type=template&id=53d040bc&scoped=true&"
import script from "./InSurance.vue?vue&type=script&lang=js&"
export * from "./InSurance.vue?vue&type=script&lang=js&"
import style0 from "./InSurance.vue?vue&type=style&index=0&id=53d040bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d040bc",
  null
  
)

export default component.exports